import * as React from 'react';

import { isNil } from 'lodash';

import LimitedFreeClassAvatar from 'assets/images/avatars/limited-free-class-avatar.svg';
import CurrentUser from 'auth/CurrentUser';
import Badge from 'components/Badge';
import Image from 'components/Image';
import Text from 'components/Text';
// @ts-ignore
import Organization from 'entities/Organization';
import { Container } from 'flux/utils';
import GroupLink from 'groups/components/GroupLink';
// @ts-ignore
import UnreadStore from 'stores/UnreadStore';

import { NavigationList_me_navigationSections_items } from 'queries/__generated__/NavigationList';

import './styles/NavigationListGroupItem.scss';

export function NavigationListGroupItemBadge(props: { unreadCount: number }) {
  return (
    <Badge
      className="NavigationListGroupItem-badge"
      count={props.unreadCount}
      color="apple"
      size="medium"
    />
  );
}

type Props = {
  group: NavigationList_me_navigationSections_items;
  district?: Organization | null;
};

type State = {
  unreadCount: number;
};

class NavigationListGroupItem extends React.Component<Props, State> {
  state = {
    unreadCount: 0,
  };

  static getStores() {
    return [UnreadStore];
  }

  static calculateState(state: State, props: Props) {
    const { group, district } = props;

    if (group.__typename !== 'Class') {
      return { unreadCount: 0 };
    }

    if (isNil(district)) {
      return {
        unreadCount: UnreadStore.getUnreadCount(group.uuid),
      };
    }

    // for district classes, we should also fetch unreads with
    // the org uuid in order to surface unreads for the chats
    // between the user and the district entity
    return {
      unreadCount:
        UnreadStore.getUnreadCount(group.uuid) + UnreadStore.getUnreadCount(district.get('uuid')),
    };
  }

  hasUnreads() {
    return this.state.unreadCount > 0;
  }

  renderBadge() {
    return (
      this.hasUnreads() && <NavigationListGroupItemBadge unreadCount={this.state.unreadCount} />
    );
  }

  renderItem() {
    const { group } = this.props;
    if (group.__typename !== 'Class') {
      console.warn(group);
      console.error(
        'NavigationListGroupItem - renderItem tried to render with an item that was not an Class'
      );
      return null;
    }

    const { hasLimitedSendFunctionality } = group;
    const currentUser = CurrentUser.getUser();
    const hasFreeProductLimitFeature =
      currentUser && currentUser.hasFeature('free_product_limits.web.apr-19');
    const showLimitedSendFunctionality = hasFreeProductLimitFeature && hasLimitedSendFunctionality;
    const avatarUrl = showLimitedSendFunctionality
      ? LimitedFreeClassAvatar
      : group.group_avatar && group.group_avatar.svgUrl;

    return (
      <React.Fragment>
        <Image width={16} className="NavigationListGroupItem-avatar" src={avatarUrl || ''} />
        <Text
          className="NavigationListGroupItem-name"
          weight={this.hasUnreads() ? 'semibold' : 'normal'}
          truncate>
          {group.displayName}
          {group.type !== 'pending' && showLimitedSendFunctionality && (
            <Text
              color="apple"
              size="xxxxsmall"
              element="div"
              truncate
              data-test="announcements-unavailable-text">
              Announcements unavailable
            </Text>
          )}
          {group.type === 'pending' && (
            <Text
              color="apple"
              size="xxxxsmall"
              element="div"
              truncate
              data-test="request-pending-text">
              Request to join pending
            </Text>
          )}
        </Text>
      </React.Fragment>
    );
  }

  render() {
    const { group } = this.props;
    if (group.__typename !== 'Class') {
      console.warn(group);
      console.error('NavigationListGroupItem - tried to render with an item that was not an Class');
      return null;
    }

    if (!group.group_avatar) {
      console.debug(this.props);
      console.error('NavigationListGroupItem - group without avatar');
      return null;
    }

    return (
      <li className="NavigationListGroupItem">
        <GroupLink className="NavigationListGroupItem-link" group={group} color="inherit">
          <div className="NavigationListGroupItem-container">
            {this.renderItem()}
            {this.renderBadge()}
          </div>
        </GroupLink>
      </li>
    );
  }
}

export { NavigationListGroupItem };
export default Container.create(NavigationListGroupItem, {
  withProps: true,
  pure: false,
});
